import { AxiosInstance } from 'axios';
import {
  processRequest as baseProcessRequest,
  CustomProcessRequestParams,
} from 'data-layer-cr/dist/network';

// Clients
import NetworkClient from './NetworkClient';
import LocalNetworkClient from './LocalNetworkClient';

// Store
import store from '../store';

// Extra
import urlIsMocked from '../__mocks__/urlIsMocked';

interface ProcessRequestParams<T> extends CustomProcessRequestParams<T> {
  client?: AxiosInstance;
}

export default async function processRequest<T>({
  method,
  url,
  cancelTokenSource,
  uniqueIdentifier = '',
  data = {},
  headers = {},
  customErrorMessage,
  supressError = false,
  retryProps,
  client = NetworkClient,
}: ProcessRequestParams<T>): Promise<T> {
  if (urlIsMocked(url)) {
    return LocalNetworkClient(method, url);
  }
  return baseProcessRequest({
    method,
    url,
    client,
    cancelTokenSource,
    uniqueIdentifier,
    data,
    headers,
    customErrorMessage,
    supressError,
    retryProps,
    reduxStore: store,
  });
}
